import React from "react";
import "../styles/LivrareFront.css";

const DeliverySection = () => {
  return (
    <section className="section livrare-section">
      <h2 className="heading-secondary">Livrare</h2>
      <p className="subheading">
        Fiecare buchet este livrat cu grijă, astfel încât să ajungă în stare
        perfectă la destinație.
      </p>
      <div className="grid-container grid-container-col-4">
        <div className="grid-item grid-item-liv grid-item-liv-left">
          <i className="fas fa-shipping-fast icon"></i>
          <p>Livrare gratuită în raza orașului Chișinău,</p>
          <p>de la 1200 lei.</p>
        </div>
        <div className="grid-item grid-item-liv grid-item-liv-right">
          <i className="fas fa-percent icon"></i>
          <p>Reduceri pentru clienți fideli.</p>
        </div>
        <div className="grid-item grid-item-liv grid-item-liv-left">
          <i className="fas fa-leaf icon"></i>
          <p>Prospețimea garantată a florilor.</p>
        </div>
        <div className="grid-item grid-item-liv grid-item-liv-right">
          <i className="fa-solid fa-envelope icon"></i>
          <p>Scrie un mesaj gratuit pentru destinatarul tău special.</p>
        </div>
      </div>
    </section>
  );
};

export default DeliverySection;
